import {
  FailedToLoad,
  GeneratedImage,
  GeneratingImage,
  ImageContainer,
  ImagesContainer,
  ImagesOptions,
  OptionContainer,
  OptionContent,
  OptionIcon,
  OptionWrapper,
  SelectedImageTag,
  SelectGeneratedHeader,
  SelectGeneratedImageContainer,
  SelectGeneratedImageEmpty,
  SelectGeneratedSubtitle,
  SelectGeneratedTitle,
  SkeletonWrapper,
} from "./styles";
import { Subtitle } from "../../../styles";
import { Divider, FlexContainer } from "../../../styles";
import {
  AIImageIcon,
  BrokenImagIcon,
  ImageIcon,
  ImageOulineIcon,
} from "../../ImagesIcons";
import { FiArrowRight } from "react-icons/fi";
import { FaCheck } from "react-icons/fa";
import InformaLogo from "../../../../../newUXAssets/images/informa_logo_circle.png";

import { useEffect, useRef, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Skeleton from "../../../../../newUXComponents/Skeleton";
import ImageGenerator from "./generate-image";
import ImageUploader from "./upload-image";
import Button, { Return } from "../../Button";
import { useSelector } from "react-redux";

const INITIAL_MAXIMUM_TOKENS = 5;

export default function Images({
  nextStep,
  previousStep,
  layout,
  setConfirmedImage,
  fileList,
  setFileList,
  select,
  setSelected,
  confirmedImage,
  uploadImgUrl,
  setUploadImgUrl,
  generatedImages,
  setGeneratedImages,
  remainingAttempts = 0,
}) {
  const ref = useRef();
  const selectUpload = () => setSelected("upload");
  const selectAI = () => {
    setSelected("AI");
  };
  const scrollToRef = () =>
    setTimeout(() => {
      ref.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  const { unlimitedImages } = useSelector((state) => state.ai_creator);
  const [awaitingAIBasedImageGeneration, setAwaitingAIBasedImageGeneration] =
    useState(false);

  const handleAwaitingAIBasedImageGeneration = (flag) => {
    setAwaitingAIBasedImageGeneration(flag);
  };

  return (
    <ImagesContainer animated={!Boolean(select)}>
      <Return
        previousStep={previousStep}
        awaitingAIBasedImageGeneration={awaitingAIBasedImageGeneration}
      />

      <Subtitle>
        <FormattedMessage id={"ai_creator.image.label"} />
      </Subtitle>

      <ImagesOptions>
        <Option
          Icon={<AIImageIcon />}
          onSelect={selectAI}
          selected={select === "AI"}
          desc={
            unlimitedImages
              ? "ai_creator.image.desc.AI_admin"
              : "ai_creator.image.desc.AI"
          }
          text={"ai_creator.image.label.AI"}
        />
        <span>
          <FormattedMessage id={"or"} />
        </span>
        <Option
          Icon={<ImageIcon />}
          onSelect={selectUpload}
          selected={select === "upload"}
          desc={"ai_creator.image.desc.upload"}
          text={"ai_creator.image.label.upload"}
        />
      </ImagesOptions>

      {select && <Divider animated />}

      {select === "upload" && (
        <OptionWrapper>
          <ImageUploader
            layout={layout}
            nextStep={nextStep}
            fileList={fileList}
            setFileList={setFileList}
            confirmedImage={confirmedImage}
            setConfirmedImage={setConfirmedImage}
            uploadImgUrl={uploadImgUrl}
            setUploadImgUrl={setUploadImgUrl}
          />
        </OptionWrapper>
      )}

      {select === "AI" && (
        <OptionWrapper>
          <ImageGenerator
            setGeneratedImages={setGeneratedImages}
            scrollToRef={scrollToRef}
            handleAwaitingAIBasedImageGeneration={
              handleAwaitingAIBasedImageGeneration
            }
            awaitingAIBasedImageGeneration={awaitingAIBasedImageGeneration}
          />
          <Divider animated margin="16px 0" />
          <SelectAIImage
            confirmedImage={confirmedImage}
            nextStep={nextStep}
            setConfirmedImage={setConfirmedImage}
            generatedImages={generatedImages}
            total={INITIAL_MAXIMUM_TOKENS}
            remainingAttempts={remainingAttempts}
            handleAwaitingAIBasedImageGeneration={
              handleAwaitingAIBasedImageGeneration
            }
            awaitingAIBasedImageGeneration={awaitingAIBasedImageGeneration}
          />
          <div ref={ref} />
        </OptionWrapper>
      )}
    </ImagesContainer>
  );
}

function Option({ Icon, text, desc, selected, onSelect }) {
  return (
    <OptionContainer selected={selected} onClick={onSelect}>
      <OptionIcon>{Icon}</OptionIcon>
      <OptionContent>
        <p>
          <FormattedMessage id={text} />
        </p>
        <span>
          <FormattedMessage id={desc} />
        </span>
      </OptionContent>
    </OptionContainer>
  );
}

function SelectAIImage({
  generatedImages = [],
  total = 5,
  nextStep,
  setConfirmedImage,
  confirmedImage,
  remainingAttempts = 0,
  handleAwaitingAIBasedImageGeneration,
  awaitingAIBasedImageGeneration = false,
}) {
  const intl = useIntl();
  const [selectGenerated, setSelectGenerated] = useState(null);
  const { unlimitedImages } = useSelector((state) => state.ai_creator);

  useEffect(() => {
    const findConfirmed = generatedImages.find(
      (image) => image === confirmedImage,
    );
    if (findConfirmed) {
      return setSelectGenerated(findConfirmed);
    }
  }, [confirmedImage, generatedImages]);

  const handleSelect = (imageUrl) => {
    setSelectGenerated((prev) => (prev === imageUrl ? null : imageUrl));
  };

  const foward = () => {
    if (!selectGenerated) return;
    setConfirmedImage(selectGenerated.src);
    nextStep();
  };

  return (
    <div>
      <FlexContainer spaceBetween>
        <SelectGeneratedHeader>
          <SelectGeneratedTitle>
            {intl.formatMessage({ id: "ai_creator.generatedImages" })}
            {!unlimitedImages && (
              <span className="warningToken">
                {intl.formatMessage(
                  { id: "warning_available_token_message" },
                  {
                    usedTokens: total - remainingAttempts,
                    initialMaximum: total,
                    availableTokens: remainingAttempts,
                  },
                )}
              </span>
            )}
          </SelectGeneratedTitle>
          <SelectGeneratedSubtitle>
            <FormattedMessage id={"ai_creator.generatedImages.select"} />
          </SelectGeneratedSubtitle>
        </SelectGeneratedHeader>

        <FlexContainer width="253px">
          <Button
            theme={"useGenerated"}
            label={"ai_creator.generatedImages.button"}
            icon={<FiArrowRight size={20} />}
            disabled={
              selectGenerated === null || awaitingAIBasedImageGeneration
            }
            onClick={foward}
          />
        </FlexContainer>
      </FlexContainer>

      <SelectGeneratedImageContainer>
        {generatedImages.length === 0 && <NoGenerated />}
        {generatedImages.map((image, i) => (
          <ImageWithLoading
            handleSelect={handleSelect}
            image={image}
            selected={selectGenerated === image}
            key={i}
            awaitingAIBasedImageGeneration={awaitingAIBasedImageGeneration}
          />
        ))}
      </SelectGeneratedImageContainer>
    </div>
  );
}

function ImageWithLoading({
  handleSelect,
  image,
  selected,
  awaitingAIBasedImageGeneration = false,
}) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <ImageContainer>
      {loading && image?.generating && (
        <SkeletonWrapper>
          <GeneratingImageLoad />
        </SkeletonWrapper>
      )}

      {loading && !image?.generating && (
        <SkeletonWrapper>
          <Skeleton width={380} height={380} borderRadius={"0px"} />
        </SkeletonWrapper>
      )}

      {error && (
        <FailedToLoad className="failed" isLoading={loading}>
          <BrokenImagIcon />
          <p>
            <FormattedMessage id={"load_fail"} />
          </p>
        </FailedToLoad>
      )}

      {image.src && (
        <GeneratedImage
          error={error}
          isLoading={loading}
          loading="lazy"
          src={image.src}
          onClick={() => {
            if (error) return;
            handleSelect(image);
          }}
          selected={selected}
          onLoad={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
        />
      )}

      <SelectedImageTag selected={selected}>
        <FormattedMessage id="ai_creator.generatedImages.selected" />{" "}
        <FaCheck size={10} />
      </SelectedImageTag>
    </ImageContainer>
  );
}

function NoGenerated() {
  return (
    <SelectGeneratedImageEmpty>
      <ImageOulineIcon />
      <p>
        <FormattedMessage id={"ai_creator.generatedImages.nothingHere"} />
      </p>
      <span>
        <FormattedMessage id={"ai_creator.generatedImages.nothingHere.desc"} />
      </span>
    </SelectGeneratedImageEmpty>
  );
}

function GeneratingImageLoad() {
  return (
    <GeneratingImage>
      <div>
        <Skeleton
          width={380}
          height={380}
          borderRadius={"0px"}
          duration={2.4}
        />
      </div>
      <div>
        <img src={InformaLogo} alt="Informa Logo" />
        <div class="words">
          <span class="word">
            <FormattedMessage id="ai_creator_generating_image" />
          </span>
          <span class="word">
            <FormattedMessage id="ai_creator_generating_please_wait" />
          </span>
          <span class="word">
            <FormattedMessage id="ai_creator_generating_image" />
          </span>
          <span class="word">
            <FormattedMessage id="ai_creator_generating_please_wait" />
          </span>
          <span class="word">
            <FormattedMessage id="ai_creator_generating_image" />
          </span>
        </div>
      </div>
    </GeneratingImage>
  );
}
